<style scoped>
.el-col-5{
  width: 30%;
}
.ab-detail-text{
  font-size: 18px;
  text-align: left;
  padding-left: 26px;
}
/deep/.ab-detail .el-dialog__body{
    padding-top: 10px!important;
}
/deep/.ab-add-detail .el-dialog__body{
    padding: 0px!important;
    padding-top: 10px!important;
}
.ab-list-box{
  display: flex;
  padding: 0 50px;
}
.ab-list-left{
  width: 90px;
  flex-shrink: 0;
}
.ab-list-right{
  width: 100%;
  padding: 10px 20px 40px 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-align: left;
}
.ab-menu-total{
  font-size: 17px;
  font-weight: bold;
  text-align: left;
}
.menu-header{
  background: #4fa1a4;
}
.menu-num{
  color: red;
  text-decoration: underline;
  cursor: pointer;
}
/* 弹框选项卡 */
.add-edit-box{
  display: flex;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.table-tab{
  flex: 1;
}
.menu-tab{
  width: 25%;
  /* float:left; */
  padding:15px;
  box-sizing: border-box;
  border-right: 1px solid #ddd;
}
.tab-plane{
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  /* border-radius: 6px; */
  
}
.tab-plane .tab-list{
  width: 50%;
  line-height: 32px;
  background: rgb(240, 239, 239);
  cursor: pointer;
  border:1px solid #ddd;
  /* border-radius: 6px; */
}
.tab-active{
  background: #fff!important;
  border: 1px solid #4fa1a4!important;
}
.tags-logo{
  width: 16px;
  margin-top: 2px;
  margin-right: 10px;
}
.tags-edit{
  width: 20px;
  margin-top: 2px;
  margin-right: 10px;
}
.tags-del{
  width: 16px;
  margin-top: 2px;
}
.tags-list{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  /* line-height: 40px; */
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}
.tags-list-left{
  width: calc(100% - 40px);
  display: flex;
  align-items: center;
}
.tags-list:hover{
  background: rgb(245, 244, 244);
}
.tags-active{
  color: #4fa1a4!important;
  background: rgb(245, 244, 244);
}
.edit-tags-text{
  padding: 0 80px;
  display: flex;
}
.el-icon-check{
  color: #4fa1a4;
}
.add-edit-search{
  margin: 20px 0;
  padding-bottom: 35px;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
}
.ab-detail-person{
  float: right;
  margin-right: 28px;
  font-size: 14px;
  font-weight: 400;

}
.no-tag-data{
  color: #909399;
}
.tags-list-left span{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="7"
          ><div class="search-area-div">企业：</div>
          <!-- <el-input v-model="page.tenantGuid" class="ipt-sty" placeholder="请输入岗位"></el-input> -->
          <el-select v-model="page.tenantGuid" placeholder="请选择" class="ipt-sty">
            <el-option
            v-for="item in tenantList"
            :key="item.guid"
            :label="item.tenantName"
            :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7"
          ><div class="search-area-div">组织/标签：</div>
          <el-input v-model="page.organisationName" class="ipt-sty" placeholder="请输入"></el-input
        ></el-col>
        <el-col :span="5">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加A/B测试</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="企业" header-align="left" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="labelName" label="组织/标签" header-align="center" align="center"></el-table-column>
        <el-table-column prop="unitCount" label="产品单元数" header-align="center" align="center" width="100"></el-table-column> 
        <el-table-column prop="createUser" label="操作员" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="updateTime" label="操作时间"  header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <!-- <a class="txt-color" @click="dialogTableDetail = true">详情 | </a> -->
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- 查看表格详情 -->
    <!-- <el-dialog title="查看详情" :visible.sync="dialogTableDetail" width="70%" custom-class="ab-detail">
      <div class="ab-detail-box">
        <p class="ab-detail-text">销售人员标签 已选 <span class="fontC-red"> 2 </span> 个产品单元</p>
        <div class=" back-color-fff" style="padding: 16px;"> 
        <el-table :data="tableData"  border style="width: 100%;" v-loading="tableLoading" >
            <el-table-column label="序号" width="60" header-align="left" align="left">
            <template slot-scope="scope">
                {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
            </template>
            </el-table-column>
            <el-table-column prop="positionName" label="产品单元名称" header-align="left" align="left"></el-table-column>
            <el-table-column prop="positionName" label="版本" header-align="left" align="left"></el-table-column>
            <el-table-column prop="positionPeopleNum" label="描述" header-align="left" align="left"></el-table-column> 
            <el-table-column prop="positionName" label="状态" header-align="left" align="left"></el-table-column>
            <el-table-column prop="createTime" label="操作时间"  header-align="left" align="left">
            <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
            </el-table-column>
            <el-table-column prop="positionPeopleNum" label="菜单数" header-align="left" align="left">
              <template slot-scope="scope">
                <a class="menu-num" @click="toMenuDetail()">5</a>
              </template>
            </el-table-column>
            <el-table-column label="开发清单" header-align="center" align="center">
            <template slot-scope="scope">
                <a class="txt-color" @click="toListDetail(0, scope.row)">查看详情 </a>
            </template>
            </el-table-column>
        </el-table>
        </div>
        <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
        >
        </el-pagination>
      </div>
    </el-dialog> -->
    <!-- 查看清单 -->
    <el-dialog title="查看清单" :visible.sync="dialogListDetail" width="600px" custom-class="ab-detail">
      <el-row class="pl40">
        <el-col :span="4">开发清单：</el-col>
        <el-col :span="16">
          <el-input type="textarea" :rows="10" readonly placeholder="请输入内容" v-model="listDetailInfo">
          </el-input>
        </el-col>
      </el-row>
      <!-- <div class="ab-list-box">
       <div class="ab-list-left ">开发清单：</div>
       <div class="ab-list-right">
          <p>问题：</p>
          <p>无</p>
          <p></p>
          <p>内容：</p>
          <p>1、更新文字大小</p>
          <p>2、输入框限制字数</p>
       </div>
      </div> -->
    </el-dialog>
    <!-- 查看菜单 -->
    <el-dialog title="查看菜单" :visible.sync="dialogMenuDetail" width="70%" custom-class="ab-detail">
      <div class="ab-menu-box">
        <p class="ab-menu-total">【建档】产品单元，共有{{menusDetail.length}}个菜单</p>
        <el-table
        :data="menusDetail"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all
        :header-cell-style="{background:'#4fa1a4',color:'#fff',fontWeight:400}"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="menuName" label="菜单名称" width="180" header-align="center" align="center"></el-table-column>
          <el-table-column  prop="orderNum" label="排序" width="180" header-align="center" align="center">1</el-table-column>
          <el-table-column property="bizState" label="应用状态" header-align="center" align="center">
            <template slot-scope="scope">{{scope.row.bizState=='Y'?'有效':'无效'}}</template>
          </el-table-column>
          <el-table-column property="visible" label="显示状态" header-align="center" align="center">
            <template slot-scope="scope">{{scope.row.visible=='Y'?'显示':'不显示'}}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 添加/编辑 -->
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="90%" custom-class="ab-add-detail">
      <div class="add-edit-box">
         <!-- 左侧标签页 -->
        <div class="back-color-fff  menu-tab">
            <el-select v-model="tenantDataGuid" placeholder="请选择" class="w100f mb15" @change="tenantChange">
                <el-option
                v-for="item in tenantList"
                :key="item.guid"
                :label="item.tenantName"
                :value="item.guid">
                </el-option>
            </el-select>
            <div class="tab-plane">
                <div :class="tabType==1?'tab-list tab-active':'tab-list'" @click="tabChange(1)" >组织架构</div><div :class="tabType==2?'tab-list tab-active':'tab-list'" @click="tabChange(2)">标签</div>
            </div>
            <!-- 组织架构 -->
            <div class="block" v-if="tabType==1">
              <el-tree
              :data="superiorOrganization"
              ref="tree"
              class="mt10 mb10"
              node-key="guid"
              :filter-node-method="filterNode"
              :props="defaultPropsOrganisation"
              @node-click="handleNodeCilck"
              :highlight-current="true"
              :default-expanded-keys="[organisationGuid]"
              >
              </el-tree>
            </div>
            <!-- 标签 -->
            <div class="block mt15" v-if="tabType==2">
              <div :class="tagGuid == item.guid ?'tags-list tags-active':'tags-list'" v-for="(item,index) in tagsList" :key="index" @click="tagsSelect(item, index)">
                <div class="tags-list-left"><img class="tags-logo" src="../../assets/images/tab_tags.png" alt="">
                <span> {{item.labelName}}</span></div>
                <div class="tags-list-right" v-if="tagGuid == item.guid"><i class="el-icon-check"></i></div>
              </div>
              <p class="no-tag-data" v-if="tagsList.length == 0">暂无数据</p>
            </div>
        </div>
        <div class="table-tab">
          <div class="search-area add-edit-search">
            <el-row :gutter="24">
                <el-col :span="10"><div class="search-area-div w110">产品单元名称：</div>
                <el-input v-model="pageProduct.productUnitName" class="w60f" placeholder="请输入产品单元名称"></el-input></el-col>
                <el-col :span="8"><div class="search-area-div">状态：</div>
                  <el-select v-model="pageProduct.state" placeholder="请选择">
                    <el-option
                    v-for="item in stateOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <el-button size="medium" type="info" @click="getProductData(true)">搜索</el-button>
                  <el-button size="medium" type="danger" @click="emptyProductData()">清空</el-button>
                </el-col>
            </el-row>
          </div>
          <p class="ab-detail-text">已选 <span class="fontC-red"> {{productUnitGuids.length}} </span> 个产品单元 
          </p>
            <div class=" back-color-fff" style="padding: 16px 26px;"> 
              <el-table ref="multipleTable" :data="productTableData.slice((pageProductIndex-1)*pageProductSize,pageProductIndex*pageProductSize)"  border style="width: 100%;" v-loading="tableLoading" row-key="guid" @selection-change="handleSelectionChangePro">
                <el-table-column type="selection" width="60" header-align="center" align="center" :reserve-selection="true"></el-table-column>
                <el-table-column label="序号" width="60" header-align="left" align="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
                </el-table-column>
                <el-table-column prop="productUnitName" label="产品单元名称" header-align="center" align="center"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="version" label="版本" header-align="center" align="center"></el-table-column>
                <el-table-column prop="remark" label="描述" header-align="center" align="center"></el-table-column>
                <el-table-column prop="state" label="状态" header-align="center" align="center">
                  <template slot-scope="scope">
                    {{scope.row.state == 'I'?'初始':scope.row.state=='U'?'上线':'下线'}}
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="操作时间" header-align="center" align="center">
                  <template slot-scope="scope">
                    {{scope.row.updateTime | getDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="menuQty" label="菜单数" header-align="center" align="center">
                <template slot-scope="scope">
                    <a class="menu-num" @click="toMenuDetail(scope.row)">{{scope.row.menuQty}}</a>
                </template>
                </el-table-column>
                <el-table-column label="开发清单" header-align="center" align="center">
                <template slot-scope="scope">
                    <a class="txt-color" @click="toListDetail(scope.row)">查看详情 </a>
                </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
            class="pt pb back-color-fff"
            background
            @size-change="handleSizeChangePro"
            @current-change="handleCurrentChangePro"
            :page-sizes="[10, 100, 200]"
            :current-page="pageProductIndex"
            :page-size="pageProductSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageProductRow"
            >
            </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info"  @click="upDateForm(1)">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '添加A/B测试',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      stateOption: [{
          value: 'I',
          label: '初始'
        },
        {
          value: 'U',
          label: '上线'
        },
        {
          value: 'D',
          label: '下线'
        }
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationName: ''
      },
      pageProduct:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        productUnitName: '',
        state: ''
      },
      pageProductSize:10,
      pageProductIndex:1,
      pageProductRow:0,
      tableData: [],
      productTableData:[],
      multipleSelection: [],
      tableLoading:false,
      dialogTableDetail:false,
      dialogListDetail:false,
      dialogMenuDetail:false,
      tabType:1,
      areaData:[],
      defaultPropsOrganisation: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
      filterText: '',
      superiorOrganization: [],
      tagsIndex:0,
      pageTag:{
        pageIndex:1,
        pageSize:-1,
        labelName:'',
        totalPage: 0,
        totalRows: 0,
      },
      company: '',
      menusDetail: [],
      listDetailInfo:'',
      tenantList:[],
      tenantDataGuid:'3d3861e610cb40218d3ecf641147affd',
      organisationGuid:'',
      //标签
      tagsList:[],
      tagGuid:'',
      tagsIndex:0,
      //产品单元Guid
      productUnitGuids:[],
      tableGuid:'',
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenantData();
  },
  methods: {
    dealSelectProduct() {
      const self = this;
      console.log('*******************************************')
      console.log(this.productTableData)
      console.log(this.productUnitGuids)
      setTimeout(() => {
        this.productTableData
        .filter(k =>{return this.productUnitGuids.find(j => k.guid === j)})
        .forEach(data =>{
          this.$refs.multipleTable.toggleRowSelection(data, true);
    
        });
      }, 0);

    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationName: '', 
      },
      self.pageProductSize = 10,
      self.pageProductIndex = 1
      self.pageProductRow = 0 
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      this.tableLoading = true;
      self.api
      .get(`/${serverConfig.msPersonnelService}/org-label-product-unit/list?pageIndex=`+this.page.pageIndex+'&pageSize='+this.page.pageSize + `&tenantGuid=`+ this.page.tenantGuid+`&organisationName=`+this.page.organisationName)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableLoading = false;
          if(res.data.data.records !== null){
            this.tableData = res.data.data.records;
            this.page.totalRows = res.data.data.totalRows;
            this.page.totalPages = res.data.data.totalPages;
          }
        } else {
          this.tableLoading = false;
          self.$message.error(res.data.msg);
        }
      });
    },
    //产品表格数据
    getProductData() {
      this.tableLoading = true;
        this.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product-unit/data/get`, this.pageProduct).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE ) {
          if(res.data.data.records){
            console.log('列表', res)
            this.productTableData = res.data.data.records;
            this.dealSelectProduct();
            this.pageProductRow = this.productTableData.length;
          }else{
            this.productTableData = [];
            this.pageProductRow = 0
          }
          // this.pageProduct.totalPages = res.data.data.totalPages;
        } else {
          this.$message.error(res.data.msg);
        }
        this.tableLoading = false;
      })
    },
    //产品表格数据清空 
    emptyProductData(){
      this.pageProduct.state = ''; 
      this.pageProduct.productUnitName = '';
      this.getProductData()
    },
    //选项卡 
    tabChange(type){
      this.tabType = type;
      if(this.tabType == 2){
        this.getTagsList();
      }else{
        this.getSuperiorOrganization();
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    handleNodeCilck(data) {
      let self = this;
      self.organisationGuid = data.guid;
    },
    //选中标签
    tagsSelect(item,index){
      this.tagGuid = item.guid;
    },
    //获取标签列表
    getTagsList() {
      let self = this;
      let tenantGuid = '';
      self.api
      .get(`/${serverConfig.msPersonnelService}/label/list?`+'pageIndex='+this.pageTag.pageIndex+'&pageSize='+this.pageTag.pageSize + `&tenantGuid=` + this.tenantDataGuid)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records !== null){
            self.tagsList = res.data.data.records;
            // self.tagGuid = self.tagsList[0].guid;
          }else{
            self.tagsList = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取公司
    getTenantData() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201','9901','0101']
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records !== null)
            self.tenantList = res.data.data.records;
            // self.tenantList.forEach(i=>{
            //   if(i.tenantName )
            // })
            // 哈药集团营销有限公司
        } else {
          self.$message.error(res.data.msg);
        }
      }); 
    },
    tenantChange(val){
      this.tenantDataGuid = val;
      this.getSuperiorOrganization()
      this.getTagsList();
    },
    //获取组织
    getSuperiorOrganization() {
      let self = this;
      // let tenantGuid = self.$store.getters.getTenantGuid;
      self.api
      .get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?tenantGuid=` + this.tenantDataGuid)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.superiorOrganization = res.data.data;
          this.$nextTick(() =>{
            this.$refs.tree.setCurrentKey(this.organisationGuid)
          })
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //查看清单
    toListDetail(pobjec){
      this.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/product-unit/data/get-detail?guid=` + pobjec.guid +
        '&state=' + pobjec.state)
      .then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data              
          this.listDetailInfo = data.developmentList
          this.dialogListDetail = true;
        }
      })
    },
    //查看菜单
    toMenuDetail(pobjec){
      this.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/product-unit/data/get-detail?guid=` + pobjec.guid +
        '&state=' + pobjec.state)
      .then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data              
          this.menusDetail = data.menuList
          this.dialogMenuDetail = true;
        }
      })
    },
    handleSelectionChangePro(val){
      let self = this;
      const productUnitGuids = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        productUnitGuids.push(item.guid);
      });
      self.productUnitGuids = [...new Set(productUnitGuids)];
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    upDateForm(type) {
      let self = this;
      if(this.tabType == 1 && this.organisationGuid == ''){
        this.$message.error('请选择组织')
        return
      }
      if(this.tabType == 2 && this.tagGuid == ''){
        this.$message.error('请选择标签')
        return
      }
      if(this.productUnitGuids.length < 1){
        this.$message.error('请选择产品单元')
        return
      }
      if(self.tableGuid){
        let promise = {
          guid:this.tableGuid,
          tenantGuid: this.tenantDataGuid,
          organisationLabelGuid: this.tabType == 2?this.tagGuid:'',
          organisationGuid: this.tabType == 1?this.organisationGuid:'',
          productUnitGuids: this.productUnitGuids,
        };
        self.api.put(`/${serverConfig.msPersonnelService}/org-label-product-unit/update`, promise).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.dialogFormVisible = false;
            self.$message.success('修改成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }else{
        let promise = [{
          tenantGuid: this.tenantDataGuid,
          organisationLabelGuid: this.tabType == 2?this.tagGuid:'',
          organisationGuid: this.tabType == 1?this.organisationGuid:'',
          productUnitGuids: this.productUnitGuids,
        }];
        self.api.postJson(`/${serverConfig.msPersonnelService}/org-label-product-unit/add`, promise).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.dialogFormVisible = false;
            self.$message.success('新增成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
      
    },
     add(flg, row) {
      let self = this;
      this.$nextTick(()=>{
        this.$refs.multipleTable.clearSelection()
      })
      if (flg == 1) {
        self.tableGuid = '';
        this.tenantDataGuid = '3d3861e610cb40218d3ecf641147affd';
        this.tabType = 1;
        self.textTitle = '添加A/B测试';
        this.getProductData();
        this.getSuperiorOrganization();
        this.dialogFormVisible = true;
      }else {
        self.textTitle = '编辑A/B测试';
        self.tableGuid = row.guid;
         this.getProductData();
        self.api.get(`/${serverConfig.msPersonnelService}/org-label-product-unit/detail/` + row.guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dialogFormVisible = true;
            if(res.data.data !== null){
              this.tenantDataGuid = res.data.data.tenantGuid;
              // this.tagGuid = res.data.data.organisationLabelGuid;
              // this.organisationGuid = res.data.data.organisationGuid;
              this.productUnitGuids = res.data.data.productUnitGuids;
              this.dealSelectProduct();
              if(res.data.data.organisationGuid){
                this.tabType = 1;
                this.organisationGuid = res.data.data.organisationGuid;
                this.getSuperiorOrganization();
                this.$nextTick(() => {
                  this.$refs.tree.setCurrentKey(this.organisationGuid)
                }, 0);
              }else{
                this.tabType = 2;
                this.tagGuid = res.data.data.organisationLabelGuid;
                this.getTagsList()
              }
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.tableLoading = true;
          self.api
            .postJson(`/${serverConfig.msPersonnelService}/org-label-product-unit/del`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除成功');
                this.tableLoading = false;
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
                this.tableLoading = false;
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleSizeChangePro(val) {
      let self = this;
      self.pageProductSize = val;
      // this.getProductData();
    },
    handleCurrentChangePro(val) {
      let self = this;
      self.pageProductIndex = val;
      // this.getProductData();
    },
  },
};
</script>
